import { useMemo } from 'react';
import type { BaseIntegrationEntity, IntegrationProviders, SyncStatus } from '@vy/types';
import { SYNC_STATUSES } from '@vy/types';
import { isNullOrUndefined, withDefault } from '@vy/utils';
import { findIntegrationByProviderInEntities } from '@vy/services';

type UseIntegrationSyncStatusResult = {
  syncStatus: SyncStatus;
  syncStatusUpdatedAt: Date;
  integrationEntity?: BaseIntegrationEntity;
};

export function useIntegrationSyncStatus(
  integrationEntities: BaseIntegrationEntity[],
  integrationProvider: IntegrationProviders,
): UseIntegrationSyncStatusResult {
  return useMemo(() => {
    const integrationEntity = findIntegrationByProviderInEntities(integrationEntities, integrationProvider);

    if (isNullOrUndefined(integrationEntity)) {
      return {
        syncStatus: SYNC_STATUSES.None,
        syncStatusUpdatedAt: new Date(),
        integrationEntity: undefined,
      };
    }

    const syncStatus = withDefault(integrationEntity.syncStatus, SYNC_STATUSES.None);
    const syncStatusUpdatedAt = integrationEntity.updatedAt;

    return {
      syncStatus,
      syncStatusUpdatedAt,
      integrationEntity,
    };
  }, [integrationEntities, integrationProvider]);
} 